import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import classnames from 'classnames';
import { PortalConfigContext, getConfig } from '../../../../../config/portal';
import {
  getCurrencySymbol,
  getCurrencyFormat
} from '../../../../../utils/uomHelper';
import { DEBOUNCE_TIMEOUT_LONG } from '../../../../../constants';
import debounce from 'lodash/debounce';
import { injectIntl } from 'react-intl';
import messages from '../../../../../utils/translationMessages';
import './styles.css';
import { evaluateMinMaxChanges } from '../utils';
import { SimpleDropdownList } from '@dmm/lib-react-ui-components';
class FilterPrice extends PureComponent {
  state = {
    min: this.props.min || '',
    max: this.props.max || '',
    currencyMinClass: '',
    currencyMaxClass: '',
    editing: false,
    selectedCurrency: this.props.userCurrency || this.getDefaultCurrencyCode(),
    currencyKey: 0
  };

  updateMultiInput() {
    if (!this.state.editing) {
      this.setState({ max: this.props.max || '' });
    }
    if (!this.state.editing) {
      this.setState({ min: this.props.min || '' });
    }
    this.handleCurrencyClass();
  }

  updateCurrencyCode(){
    this.setState((prev) => ({
      ...prev,
      selectedCurrency: this.props.userCurrency || this.getDefaultCurrencyCode(),
      currencyKey: prev.currencyKey + 1
    }));
  }

  componentDidMount() {
    this.updateMultiInput();
    this.updateCurrencyCode();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.userCurrency !== this.props.userCurrency) {
      this.updateCurrencyCode();
    }
    this.updateMultiInput();
  }

  getDefaultCurrencyCode() {
    const currentLocale = get(this.props, 'intl.locale', null);
    return get(
      getConfig(),
      `languages.${currentLocale}.currency.abbr`,
      null
    );
  }

  handleDataChange(type, value) {
    if (value) {
      value = String(Math.trunc(value));
    }

    this.setState((state) => ({
      ...state,
      [type]: value
    }));
    if (this.state[type] === value) {
      return;
    }
    if (type === 'min') {
      if (this.props.tracking) {
        if (!value) {
          this.debounceTrackingRemove('minimum price removed');
        } else {
          this.debounceTracking({ ['price']: { 'min': value } });
        }
      }
      const { min, max } = evaluateMinMaxChanges(value, this.state.max, type);
      this.props.handleDataChange('price', {
        min: this.state.editing ? value : min,
        max: this.state.editing ? this.state.max : max
      });
    } else {
      if (this.props.tracking) {
        if (!value) {
          this.debounceTrackingRemove('maximum price removed');
        } else {
          this.debounceTracking({ ['price']: { 'max': value } });
        }
      }
      const { min, max } = evaluateMinMaxChanges(this.state.min, value, type);
      this.props.handleDataChange('price', {
        min: this.state.editing ? this.state.min : min,
        max: this.state.editing ? value : max
      });
    }
  }

  handleOnEdit(editingState, type) {
    this.setState(
      (state) => ({ ...state, editing: editingState }),
      () => {
        if (!editingState) {
          const valueToPass = type === 'min' ? this.state.min : this.state.max;
          this.handleDataChange(type, valueToPass);
        }
      }
    );
  }

  debounceTracking = debounce(
    (value) => this.props.tracking.facetAdded(value),
    DEBOUNCE_TIMEOUT_LONG
  );
  debounceTrackingRemove = debounce(
    (value) => this.props.tracking.facetRemoved(value),
    DEBOUNCE_TIMEOUT_LONG
  );

  handleCurrencyClass() {
    let currencyMinClass = this.state.currencyMinClass;
    let currencyMaxClass = this.state.currencyMaxClass;
    let currencyFormat = getCurrencyFormat();

    if (parseInt(this.state.min)) {
      currencyMinClass = `currency-symbol-${
        currencyFormat === 'postfix' ? 'suffix' : currencyFormat
      }`;
    } else {
      currencyMinClass = '';
    }

    if (this.state.max) {
      currencyMaxClass = `currency-symbol-${
        currencyFormat === 'postfix' ? 'suffix' : currencyFormat
      }`;
    } else {
      currencyMaxClass = '';
    }

    this.setState({ currencyMinClass, currencyMaxClass });

    return;
  }

  handleCurrencyChange(value) {
    this.setState((prev) => ({
      ...prev,
      selectedCurrency: value
    }));
    this.props.handleCurrencyChange('currency', value);
  }

  render() {
    const {
      intl: { formatMessage: t }
    } = this.props;
    const placeholderMin = this.props.isThreeColumnLayout
      ? t(messages.quickSearch.min)
      : t(messages.priceMin);
    const placeholderMax = this.props.isThreeColumnLayout
      ? t(messages.quickSearch.max)
      : t(messages.priceMax);

    const isUsersCurrencyEnabled = get(
      this.context,
      'supports.isUsersCurrencyEnabled',
      false
    );

    return (
      <div className="search-filter price">
        <div className="search-filter-group">
          <div
            className={classnames({
              small: isUsersCurrencyEnabled,
              [this.state.currencyMinClass]: !isUsersCurrencyEnabled && this.state.currencyMinClass
            })}
          >
            {this.state.currencyMinClass && !isUsersCurrencyEnabled && (
              <span className="symbol">{getCurrencySymbol()}</span>
            )}
            <input
              type="number"
              className={classnames({ 'price-min': !isUsersCurrencyEnabled })}
              placeholder={placeholderMin}
              value={this.state.min || ''}
              onChange={(value) =>
                this.handleDataChange('min', value.target.value)
              }
              onFocus={() => this.handleOnEdit(true, 'min')}
              onBlur={() => this.handleOnEdit(false, 'min')}
              title={t(messages.priceMin)}
            />
          </div>
          <span>{t(messages.to)}</span>
          <div
            className={classnames({
              small: isUsersCurrencyEnabled,
              [this.state.currencyMaxClass]: !isUsersCurrencyEnabled && this.state.currencyMaxClass
            })}
          >
            {this.state.currencyMaxClass && !isUsersCurrencyEnabled && (
              <span className="symbol">{getCurrencySymbol()}</span>
            )}
            <input
              type="number"
              className={classnames({ 'price-max': !isUsersCurrencyEnabled })}
              name="isGoing"
              placeholder={placeholderMax}
              value={this.state.max || ''}
              onChange={(value) =>
                this.handleDataChange('max', value.target.value)
              }
              onFocus={() => this.handleOnEdit(true, 'max')}
              onBlur={() => this.handleOnEdit(false, 'max')}
              title={t(messages.priceMax)}
            />
          </div>
          {isUsersCurrencyEnabled && (
            <div className="price-dropdown">
              <SimpleDropdownList
                key={ this.state.currencyKey }
                selected={ this.state.selectedCurrency }
                onChange={(e, value) =>
                  this.handleCurrencyChange(value)
                }
                items={[
                  { text: 'USD' },
                  { text: 'DKK' },
                  { text: 'EUR' },
                  { text: 'AUD' },
                  { text: 'GBP' },
                  { text: 'NOK' },
                  { text: 'SEK' }
                ]}
              />
            </div>
          )}
        </div>
      </div>
    );
  }
}

FilterPrice.propTypes = {
  handle: PropTypes.string,
  handleDataChange: PropTypes.func.isRequired,
  initialMax: PropTypes.string,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired
  }).isRequired,
  min: PropTypes.string,
  max: PropTypes.string,
  tracking: PropTypes.shape({
    facetAdded: PropTypes.func.isRequired,
    facetRemoved: PropTypes.func.isRequired
  }),
  isThreeColumnLayout: PropTypes.bool,
  handleCurrencyChange: PropTypes.func,
  userCurrency: PropTypes.string
};

FilterPrice.contextType = PortalConfigContext;

export default injectIntl(FilterPrice);
